<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :minimalize="minimalize"
    :send-function="onSave"
    :open-function="onOpen"
  >
    <BaseInput
      :label="t['offices']['nazvanie']"
      v-model="data.name"
      :rules="['required', 'max100']"
    />
  </TemplateModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'WorkClientOfficesModal',
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    create: Boolean,
    minimalize: Boolean,
    clientId: {
      type: [Number, String],
      default: null
    }
  },
  data: () => ({
    dialog: false,
    data: {},
  }),
  computed: {
    t() {
      return this.localStorage.translations.pages['setting-client']
    },
    text() {
      return {
        button: {
          open: this.minimalize
            ? this.localStorage.translations.pages['common']['buttons']['dobavit']
            : this.t['offices-dialog-add_edit-buttons']['sozdat-filial'],
        },
        title: {
          create: this.t['offices-dialog-add_edit']['sozdanie-filiala'],
          edit: this.t['offices-dialog-add_edit']['redaktirovanie-filiala']
        }
      }
    },
    params() {
      return {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
        id: this.$route.params.id,
      }
    }
  },
  methods: {
    ...mapActions('workClientOffices', [
      'onWorkClientOfficesShow',
      'onWorkClientOfficesCreate',
      'onWorkClientOfficesGrid',
      'onWorkClientOfficesAll',
      'onWorkClientOfficesUpdate',
    ]),
    async onOpen() {
      if (this.id)
        await this.onWorkClientOfficesShow(this.id)
          .then(res => {
            this.data = res.data.data
          })
      else
        this.data = {}
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      this.data.work_client_id = this.clientId || this.$route.params.id
      if (this.data.id)
        await this.onWorkClientOfficesUpdate(this.data)
          .then(() => {
            this.onWorkClientOfficesGrid(this.params)
          })
      else
        await this.onWorkClientOfficesCreate(this.data)
          .then(() => {
            if (this.$route.name === 'clientsCompanyShow') {
              if (this.$route.query.tab === 'address')
                this.onWorkClientOfficesAll(this.$route.params.id)
              else
                this.onWorkClientOfficesGrid(this.params)
            } else
              this.onWorkClientOfficesAll(this.clientId || this.$route.params.id)
          })
    }
  },
}
</script>
